import { render, staticRenderFns } from "./pocDetail.vue?vue&type=template&id=d6ce9a5c"
import script from "./pocDetail.vue?vue&type=script&lang=js"
export * from "./pocDetail.vue?vue&type=script&lang=js"
import style0 from "./pocDetail.vue?vue&type=style&index=0&id=d6ce9a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports